module.exports = __webpack_public_path__ + "img/ew-icon_crowd-manager.643ca88c.svg";